import {
    ACCOUNT_UUID,
    DEFAULT_FORM_VALUES,
    DIMENSIONS,
    END_DATE,
    FILTERS,
    FORMAT,
    FREQUENCY,
    INTERNAL_METRICS, INTERVAL_DIMENSION,
    IS_SCHEDULED,
    METRICS, MONETIZATION_METRICS,
    PERFORMANCE_METRICS,
    PREBID_MONETIZATION_METRICS,
    PREBID_VIDEO_METRICS,
    RECIPIENTS,
    REPORT_FROM,
    REPORT_NAME, REPORT_RANGE,
    REPORT_TO,
    REPORT_UUID,
    SCHEDULE, STANDARD_DIMENSION,
    START_DATE
} from "../consts";

export const validate = (formValues, formValuesFromDB = DEFAULT_FORM_VALUES, reportNames = []) => {
    if (reportNames.includes(((formValues || {})[REPORT_NAME] || '').toLowerCase())) return false
    if (!formValues || !formValuesFromDB) return false
    if (
        (formValues[ACCOUNT_UUID] || formValues[REPORT_UUID] === 'newReport') &&
        formValues[REPORT_NAME] &&
        (formValues[DIMENSIONS].length) &&
        (formValues[METRICS].length) &&
        formValues[FILTERS] &&
        formValues[SCHEDULE][FORMAT] &&
        formValues[SCHEDULE][FREQUENCY]
    ) {
        if (formValues[REPORT_RANGE] ===  'CUSTOM' && (!formValues[REPORT_FROM] || !formValues[REPORT_TO])) {
            return false;
        }
        if (formValues[IS_SCHEDULED] && (!formValues[SCHEDULE][START_DATE] || !formValues[SCHEDULE][END_DATE] || !formValues[SCHEDULE][RECIPIENTS].length)) {
             return false;
        }
        const diff = formDiff(formValues, formValuesFromDB)

        Object.keys(formValuesFromDB[SCHEDULE]).forEach(k => {
            if (JSON.stringify(formValuesFromDB[SCHEDULE][k]) !== JSON.stringify(formValues[SCHEDULE][k])) {
                diff.push(k)
            }
        })

        if (JSON.stringify(formValuesFromDB[SCHEDULE][RECIPIENTS]) !== JSON.stringify(formValuesFromDB[SCHEDULE][RECIPIENTS])) diff.push(RECIPIENTS)

        return diff.length > 0;
    } else return false;
}

export const formDiff = (formValues, formValuesFromDB) => {
    if(formValuesFromDB === undefined) return false;
    return Object.keys(formValuesFromDB).filter(k => {
        if (k === IS_SCHEDULED || k === SCHEDULE || k === INTERNAL_METRICS) return false;
        if (k === METRICS) {
            return JSON.stringify(formValuesFromDB[k]) !== JSON.stringify([...formValues[MONETIZATION_METRICS],...formValues[PERFORMANCE_METRICS], ...formValues[PREBID_MONETIZATION_METRICS], ...formValues[PREBID_VIDEO_METRICS]])
        } else {
            return JSON.stringify(formValuesFromDB[k]) !== JSON.stringify(formValues[k])
        }
    });
}